import React from 'react';
import AppsIcon from '@material-ui/icons/Apps';

class Navbar extends React.Component{
    render(){
        return (
            <nav className="navbar navbar-expand-lg navbar-light bg-light" style={{marginBottom: "30px"}}>
                <div className="container-fluid">
                    <button type="button" id="sidebarCollapse" className="btn btn-primary btn-sm">
                        <AppsIcon />
                    </button>
                    <h2>{this.props.title}</h2>
                </div>
            </nav>
        );
    }
}

export default Navbar;